module.exports = __webpack_public_path__ + "img/pl.74581b48.svg";